import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PeriodicType } from 'app/shared/model/enumerations/periodicType';
import { ReportType } from './types/reports.types';

interface IReportsState {
  isGenerating: boolean;
  activeJobId: string | null;
  activeReportType: ReportType | null;
  reportType: ReportType;
  periodicType: PeriodicType;
  dateStart: string;
  dateEnd: string;
  searchCompanyName: string;
  selectedVehicleIds: number[];
}

const initialState: IReportsState = {
  isGenerating: false,
  activeJobId: null,
  activeReportType: null,
  reportType: ReportType.DAILY,
  periodicType: PeriodicType.YESTERDAY,
  dateStart: '',
  dateEnd: '',
  searchCompanyName: '',
  selectedVehicleIds: [],
};

export const reportsSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    setGenerating(state, action: PayloadAction<boolean>) {
      state.isGenerating = action.payload;
      if (!action.payload) {
        state.activeJobId = null;
        state.activeReportType = null;
      }
    },
    setActiveJobId(state, action: PayloadAction<string | null>) {
      state.activeJobId = action.payload;
    },
    setActiveReportType(state, action: PayloadAction<ReportType | null>) {
      state.activeReportType = action.payload;
    },
    setReportType(state, action: PayloadAction<ReportType>) {
      if (state.reportType !== action.payload) {
        state.reportType = action.payload;
        state.periodicType = PeriodicType.YESTERDAY;
        state.dateStart = '';
        state.dateEnd = '';
        state.searchCompanyName = '';
        state.selectedVehicleIds = [];
      }
    },
    setPeriodicType(state, action: PayloadAction<PeriodicType>) {
      state.periodicType = action.payload;
    },
    setDateStart(state, action: PayloadAction<string>) {
      state.dateStart = action.payload;
    },
    setDateEnd(state, action: PayloadAction<string>) {
      state.dateEnd = action.payload;
    },
    setSearchCompanyName(state, action: PayloadAction<string>) {
      state.searchCompanyName = action.payload;
    },
    setSelectedVehicleIds(state, action: PayloadAction<number[]>) {
      state.selectedVehicleIds = action.payload;
    },
    resetReports() {
      return initialState;
    },
  },
});

export const { setGenerating, setActiveJobId, setActiveReportType, setReportType, setPeriodicType, setDateStart, setDateEnd, setSearchCompanyName, setSelectedVehicleIds, resetReports } = reportsSlice.actions;

export default reportsSlice.reducer;
